<template>
    <Loading>
        <div class="d-flex justify-content-center p-3">
            <Row class="logo" />
        </div>
        <Divider />
        <div class="p-3">
            <Row class="w-75" />
            <Row class="w-50" />
            <Row class="button mt-4" />
        </div>
    </Loading>
</template>

<script>
import Loading from './base/Loading';
import Row from './base/Row';

export default {
    components: { Loading, Row },
};
</script>

<style scoped>
.logo {
    width: 100px !important;
    height: 100px !important;
    border-radius: 50%;
}
.button {
    height: 38px;
    border-radius: 3px;
}
</style>
